import { Component, OnInit, signal, TemplateRef, viewChild } from '@angular/core';
import { PreviewCard } from '../../components/preview-card/preview-card.class';
import { SectionTitleComponent } from '../../components/section-title/section-title.component';
import { CommonModule } from '@angular/common';
import { CarouselArrowsComponent } from '../../components/carousel-arrows/carousel-arrows.component';
import { CarouselBaseComponent } from '../../components/carousel-base/carousel-base.component';
import { ProductCardComponent } from '@core/components/product-card/product-card.component';
import { PreviewCardComponent } from '../../components/preview-card/preview-card.component';
import { SwiperOptions } from 'swiper/types';
import { CAROUSEL_BASE_DEFAULT_CONFIG } from '../../components/carousel-base/carousel-base.default-config';
import { Product } from '@core/models/piramide/Product';
import { CarouselItemBase } from '../../components/carousel-base/carousel-item-base.model';
import { NavigationService } from '@core/services/navigation.service';
import { first } from 'rxjs';
import { BombPricesSectionService } from '../../services/bomb-prices-section.service';

@Component({
  selector: 'cgw-bomb-prices',
  standalone: true,
  imports: [
    SectionTitleComponent,
    CommonModule,
    CarouselArrowsComponent,
    CarouselBaseComponent,
    ProductCardComponent,
    PreviewCardComponent,
  ],
  templateUrl: './bomb-prices.component.html',
  styleUrl: './bomb-prices.component.scss',
})
export class BombPricesComponent implements OnInit {
  public title: string = 'Aprovechá <b>precios exclusivos</b>';
  private readonly _productTemplateRef = viewChild('bombPricesProductsTemplate', {
    read: TemplateRef,
  });
  public readonly carousel =
    viewChild<CarouselBaseComponent<Product, CarouselItemBase<Product>>>(CarouselBaseComponent);
  public bombPricesPreview = signal<PreviewCard>(null);
  public readonly carouselItems = signal<CarouselItemBase<Product>[]>([]);
  public readonly carouselConfig = signal<SwiperOptions>({
    ...CAROUSEL_BASE_DEFAULT_CONFIG,
    slidesPerView: 1.5,
    spaceBetween: 10,
    breakpoints: {
      992: {
        slidesPerView: 3,
      },
    },
  });
  constructor(
    private navigationService: NavigationService,
    private bombPricesSectionService: BombPricesSectionService,
  ) {}

  public ngOnInit(): void {
    this.bombPricesSectionService.getBombPricesPreview().subscribe((r) => {
      this.bombPricesPreview.set(
        new PreviewCard({
          id: r.id,
          class: 'brand',
          title: r.title,
          backgroundImages: r.backgroundImages,
          onClick: () => {
            this.navigationService.navigate(['/productos'], {
              queryParams: {
                alcance: 'seccionPreciosBomba',
              },
            });
          },
        }),
      );
    });
    this.bombPricesSectionService
      .getBombPricesProducts()
      .pipe(first())
      .subscribe((products) => {
        this.setFilteredProducts(products);
      });
  }

  public setFilteredProducts(filteredList: Array<Product>): void {
    this.carouselItems.set(
      filteredList.map(
        (p) =>
          new CarouselItemBase({
            id: p.id_producto,
            data: p,
            templateRef: this._productTemplateRef(),
            templateContext: { item: p },
          }),
      ),
    );
  }
}
